import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownModule, SelectButtonModule, SharedModule } from 'primeng';
import { SelectItem } from 'primeng/api';
import { RiskManagementTab } from '../../../enums/risk-management-tab.enum';
import { VmeCommonModule } from '../../../vme-common.module';
import { SupplierRiskManagementService } from '../../../services/supplier-risk-management.service';

@Component({
  selector: 'risk-management-tabs',
  standalone: true,
  imports: [CommonModule, DropdownModule, SelectButtonModule, SharedModule, VmeCommonModule],
  templateUrl: './risk-management-tabs.component.html',
  styleUrls: ['./risk-management-tabs.component.scss'],
})
export class RiskManagementTabsComponent {
  @Input() selectedTab: RiskManagementTab = RiskManagementTab.AllSuppliers;

  @Output() tabChanged = new EventEmitter<RiskManagementTab>();

  constructor(private supplierRiskManagementService: SupplierRiskManagementService) {}

  @Input() counts: Record<RiskManagementTab, number>;
  @Input() loading: boolean = false;

  loadingCounts = true;

  public inboxTabOptions: SelectItem[] = [
    {
      label: 'All Suppliers',
      value: RiskManagementTab.AllSuppliers,
    },
    {
      label: 'Assigned to You',
      value: RiskManagementTab.AssignedToYou,
    },
    {
      label: 'Assigned to Others',
      value: RiskManagementTab.AssignedToOthers,
    },
    {
      label: 'Unassigned',
      value: RiskManagementTab.Unassigned,
    },
  ];
  protected readonly Object = Object;
}
